import React, { Component } from 'react';

class About extends Component {
  render() {
    if (!this.props.data) return null;

    const { name, image, bio, resumedownload } = this.props.data;
    const profilepic = `images/${image}`;

    // Key skills to highlight
    const keySkills = [
      'Python & Java',
      'AWS & Kubernetes',
      'React & Node.js',
      'TensorFlow & PyTorch',
      'Distributed Systems',
      'CI/CD & DevOps'
    ];

    return (
      <section id="about">
        <div className="container">
          <h2>About Me</h2>

          <div className="about-content">
            <div className="about-text">
              <p>{bio}</p>

              {/* Stats Section */}
              <div className="about-stats">
                <div className="stat-item">
                  <div className="stat-number">8+</div>
                  <div className="stat-label">Years Experience</div>
                </div>
                <div className="stat-item">
                  <div className="stat-number">50+</div>
                  <div className="stat-label">Projects</div>
                </div>
                <div className="stat-item">
                  <div className="stat-number">15+</div>
                  <div className="stat-label">Technologies</div>
                </div>
              </div>

              {/* Key Skills */}
              <h3 style={{ marginTop: '2rem', marginBottom: '1rem', fontSize: '1.25rem' }}>
                Core Expertise
              </h3>
              <div className="about-skills-list">
                {keySkills.map((skill, index) => (
                  <div key={index} className="skill-item">
                    {skill}
                  </div>
                ))}
              </div>

              {/* CTA Buttons */}
              <div style={{ 
                marginTop: '3rem', 
                display: 'flex', 
                gap: '1rem', 
                flexWrap: 'wrap',
                alignItems: 'center'
              }}>
                <a
                  href={resumedownload}
                  className="button"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fa fa-file-text-o"></i>
                  <span>View Resume</span>
                </a>
                <a
                  href="/resume.pdf"
                  className="button button-secondary"
                  download="Harun_Gitundu_Resume.pdf"
                >
                  <i className="fa fa-download"></i>
                  <span>Download PDF</span>
                </a>
              </div>
            </div>

            <div className="about-image">
              <div className="profile-pic-wrapper">
                <img
                  className="profile-pic"
                  src={profilepic}
                  alt={`${name} - Profile`}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default About;
